import React from "react";
import { Euro, Timer, ShieldCheck, Cpu, Radar, MessageSquare, Wallet } from "lucide-react";

const VALUE_CARDS = [
  {
    icon: Euro,
    color: "#25D366",
    kpi: "+€18,000",
    title: "Value per club",
    body: "Average yearly recovery per sports center on otherwise-lost slots. SlotSaver keeps only 15%, the other 85% goes to the club.",
  },
  {
    icon: Timer,
    color: "#FFCC00",
    kpi: "< 30 sec",
    title: "Booking speed",
    body: "From the cancellation webhook (T0) to the interactive WhatsApp notification in under 30 seconds. Book in a single tap.",
  },
  {
    icon: ShieldCheck,
    color: "#007AFF",
    kpi: "0 conflicts",
    title: "Anti-double-booking",
    body: "Atomic lock on MongoDB (find_one_and_update VACANT→LOCK): the first “Yes” wins, everyone else gets a 409. Zero race conditions.",
  },
];

const AGENTS = [
  { icon: Radar, name: "Calendar Monitor", layer: "Ingestion", desc: "Receives the CANCELLATION webhook, computes the discount and creates the VACANT slot." },
  { icon: Cpu, name: "Matching & Optimization", layer: "Intelligence", desc: "Geo query (ST_DWithin) + category, scoring into Premium/Standard buckets." },
  { icon: MessageSquare, name: "Communication", layer: "Engagement", desc: "Interactive WhatsApp delivery, 45s TTL, atomic lock on the first Yes." },
  { icon: Wallet, name: "Transaction & Escrow", layer: "Financial", desc: "Stripe Connect capture, 15% commission, 85% payout, QR receipt." },
];

export const PitchSection = () => (
  <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16 sm:py-24" data-testid="pitch-section">
    <div className="mb-3 font-mono text-xs uppercase tracking-widest text-[#FF3B30]">
      // Submission · Fabrizio Romano x Emergent Builder's Contest
    </div>
    <h2 className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tighter text-white max-w-3xl">
      We turn cancellations into{" "}
      <span className="text-[#FFCC00]">last-minute revenue</span>.
    </h2>
    <p className="mt-4 max-w-2xl font-body text-base text-zinc-400">
      SlotSaver is an autonomous, event-driven, agent-based marketplace that monetizes slots freed
      at the last minute by padel, football, tennis courts and wellness centers.
    </p>

    {/* value cards */}
    <div className="mt-10 grid gap-4 md:grid-cols-3">
      {VALUE_CARDS.map((c) => (
        <div
          key={c.title}
          className="rounded-2xl border border-white/10 bg-[#121212] p-6 transition-colors hover:border-white/25"
          data-testid={`value-card-${c.title}`}
        >
          <span
            className="flex h-11 w-11 items-center justify-center rounded-xl"
            style={{ background: `${c.color}1a`, color: c.color }}
          >
            <c.icon size={22} strokeWidth={2.2} />
          </span>
          <p className="mt-4 font-head text-3xl font-extrabold tracking-tight" style={{ color: c.color }}>
            {c.kpi}
          </p>
          <h3 className="mt-1 font-head text-xl font-bold uppercase tracking-tight text-white">
            {c.title}
          </h3>
          <p className="mt-2 font-body text-sm leading-relaxed text-zinc-400">{c.body}</p>
        </div>
      ))}
    </div>

    {/* agents pipeline */}
    <div className="mt-14">
      <h3 className="font-head text-2xl sm:text-3xl font-bold uppercase tracking-tight text-white">
        4 autonomous agents architecture
      </h3>
      <div className="mt-6 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {AGENTS.map((a, i) => (
          <div
            key={a.name}
            className="relative rounded-2xl border border-white/10 bg-[#121212] p-5"
            data-testid={`agent-card-${i + 1}`}
          >
            <span className="font-mono text-[11px] text-zinc-600">AGENT 0{i + 1}</span>
            <a.icon size={26} className="mt-3 text-[#007AFF]" strokeWidth={2} />
            <p className="mt-3 font-head text-lg font-bold uppercase tracking-tight text-white">
              {a.name}
            </p>
            <span className="mt-1 inline-block rounded-full bg-white/5 px-2 py-0.5 font-mono text-[10px] uppercase text-[#FFCC00]">
              {a.layer}
            </span>
            <p className="mt-2 font-body text-[13px] leading-relaxed text-zinc-400">{a.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PitchSection;
